module.exports = __webpack_public_path__ + "static/media/archive.e58af5ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/archive.svg
// module id = 1500
// module chunks = 0